import React from 'react';
import {observable} from 'mobx';
import BaseContentModel from 'base-contentmodel';
import CourseOfActionComponent from './component';
import deepBind from 'deep-bind-decorator';

export class CourseOfActionOptionContentModel extends BaseContentModel {

   static _slots = {
     name: "",
     value: ""
   };
   static get _defaults() {
     return {name: "Default",
     value: "1"}
   };

   @observable
   /* @slot */ name = "";

   @observable
   /* @slot */ value = "";
 }

export class CourseOfActionImpactContentModel extends BaseContentModel {

  static _slots = {
    text: 'RichText',
    options: [CourseOfActionOptionContentModel],
  };
   static get _defaults() {
     return {text: "Default",
     options: []}
   };

  @observable
  /* @slot("RichText") */ text = "";

  @observable.shallow
  /* @slot([CourseOfActionOptionContentModel]) */ options = [];

  @observable
  selectedOption = -1;

  @observable
  @deepBind
  selectedValue = {
    get variable() {
      return `G:${this.id}_selectedValue:G`;
    },
    defaultValue: ''
  };
}

export class CourseOfActionActionContentModel extends BaseContentModel {

  static _slots = {
    impacts: [CourseOfActionImpactContentModel],
    text: "RichText",
    title: ""
  };

  static get _defaults() {
    return {
      text: "Default",
      impacts: [],
      title: ""
    }
  };



  @observable
  /* @slot(CourseOfActionImpactContentModel) */ impacts = [];

  @observable
  /* @slot("RichText") */ text = "";

  @observable
  /* @slot */ title = "";
}

export class CourseOfActionContentModel extends BaseContentModel{

  static _slots = {
    selections: [CourseOfActionActionContentModel],
    criteriaTitle: "",
    introText: "RichText",
  };
  static get _defaults() {
    return {
      criteriaTitle: "Default",
      selections: [],
    }
  };

  // define the default Component (Sim) view of this component
  Component = CourseOfActionComponent;

  @observable.shallow
  /* @slot([CourseOfActionActionContentModel]) */ selections = [];

  @observable
  /* slot */ criteriaTitle = "How will the selected action impact the following?";

  @observable
  /* slot */ introText = '';

  @observable
  selectedAction = -1;

  @observable
  @deepBind
  selectedActionIndex = {
    get variable() {
      return `G:${this.id}_selectedActionIndex:G`;
    },
    defaultValue: -1
  };

  @observable
  @deepBind
  optionValues = {
    get variable() {
      return `G:${this.id}_optionValues:G`;
    },
    defaultValue: {}
  };

}

export default CourseOfActionContentModel



// WEBPACK FOOTER //
// ./app_modules/course-of-action-activity/src/contentmodel.js